import {
  BufferGeometry,
  Float32BufferAttribute,
  Points,
  PointsMaterial,
  TextureLoader,
  Vector3,
} from "three";
import { default as dot, default as dota } from "@assets/textures/star_64.png";

export class Stars extends Points {
  private vertices: number[] = [];
  private org_vertices: number[] = [];
  private speed = 8;
  private loader = new TextureLoader();

  constructor() {
    super();

    this.position.set(0, 0, 0);
    this.rotation.set(0, 0, 0);

    for (let step = 0; step < 5500; step++) {
      const x = this.getRandomNumber(-1200, 1200);
      const y = this.getRandomNumber(-600, 600);
      const z = this.getRandomNumber(0, 3000);
      this.vertices.push(x, y, z);
      this.org_vertices.push(x, y, z);
    }

    this.geometry = new BufferGeometry();
    const text = this.loader.load(dot);
    const textA = this.loader.load(dota);

    this.material = new PointsMaterial({
      map: text,
      alphaMap: textA,
      color: 0xffffff,
      size: 16,
      transparent: true,
      depthWrite: false,
    });
  }

  private getRandomNumber(min = 0, max = 1): number {
    return Math.floor(Math.random() * (max + 1 - min) + min);
  }

  public setSpeed(speed: number): void {
    this.speed = speed;
  }

  public update(): void {
    for (let i = 0; i < this.vertices.length; i += 3) {
      const v = new Vector3(
        this.vertices[i],
        this.vertices[i + 1],
        this.vertices[i + 2],
      );
      v.z += this.speed;
      if (v.z > 3000) {
        v.x = this.getRandomNumber(-1200, 1200);
        v.y = this.getRandomNumber(-600, 600);
        v.z = 0;
        this.vertices[i] = v.x;
        this.vertices[i + 1] = v.y;
      }
      this.vertices[i + 2] = v.z;
    }
    this.geometry.setAttribute(
      "position",
      new Float32BufferAttribute(this.vertices, 3),
    );
    if (this.speed > 1) {
      this.speed -= 0.03;
    }
  }
}
